'use client'

import { useRef } from 'react'

export function MobileMenu({
  children,
  button,
  mobileMenuOpen = false,
  setMobileMenuOpen,
}: {
  children: React.ReactNode
  button: React.ReactNode
  mobileMenuOpen: boolean
  setMobileMenuOpen: (open: boolean) => void
}) {
  const menuRef = useRef<HTMLDivElement | null>(null)

  return (
    <div className='relative inline-block text-left' ref={menuRef}>
      {/* Button to toggle menu */}
      <div onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>{button}</div>

      {/* Dropdown menu */}
      {mobileMenuOpen && (
        <div className='absolute right-0 mt-2 w-36 origin-top-right rounded-xl bg-white shadow-[#C9D2DA4D] focus:outline-none z-50'>
          <div className='py-2 flex flex-col'>{children}</div>
        </div>
      )}
    </div>
  )
}

export default MobileMenu
